import { ButtonBase, LinearProgress } from "@mui/material"
import { CSSProperties, ReactNode } from "react"
import { colors } from "../../services/config/colors"
import {
  defaultBoxShadow,
  defaultTransition,
} from "../../services/config/constants"

const Button = ({
  children,
  primary,
  size = "small",
  style,
  onClick,
  disabled = false,
  loading = false,
  withShadow = true,
  withBorder = false,
  submit = false,
  ariaLabel,
}: {
  children?: ReactNode
  primary?: boolean
  size?: "small" | "normal"
  style?: CSSProperties
  onClick?:
    | (() => void)
    | ((event: React.MouseEvent<HTMLButtonElement>) => void)
  disabled?: boolean
  loading?: boolean
  withShadow?: boolean
  withBorder?: boolean
  submit?: boolean
  ariaLabel?: string
}) => {
  return (
    <ButtonBase
      type={submit ? "submit" : "button"}
      disabled={loading || disabled}
      aria-disabled={loading || disabled ? "true" : "false"}
      style={{
        width: "auto",
        height: size === "small" ? 40 : 56,
        minHeight: size === "small" ? 40 : 56,
        backgroundColor: primary ? colors.primary : colors.backgroundWhite,
        borderRadius: size === "small" ? 10 : 16,
        fontSize: size === "small" ? 12 : 16,
        fontWeight: size === "small" ? 900 : 700,
        color: primary ? colors.textWhite : colors.primary,
        boxShadow: withShadow ? defaultBoxShadow : "none",
        border: withBorder ? "1.5px solid " + colors.primary : "none",
        opacity: loading || disabled ? 0.4 : 1,
        transition: defaultTransition,
        overflow: "hidden",
        ...style,
      }}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {children}
      {loading && (
        <LinearProgress
          style={{ width: "100%", position: "absolute", bottom: 0 }}
        />
      )}
    </ButtonBase>
  )
}

export default Button
